import { ChevronRightIcon } from "@heroicons/react/24/solid";
import HomeIcon from "@mui/icons-material/Home";
import Typography from "@mui/material/Typography";
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import { BreadcrumbLinkStyled, BreadcrumbStyled } from "./styles";

const formatBreadcrumb = (segment) => {
  if (!segment || typeof segment !== "string") return "";

  try {
    const decoded = decodeURIComponent(segment);

    // Replace dashes with spaces
    const spaced = decoded.replace(/-/g, " ");

    const words = spaced.split(" ");

    const formatted = words
      .map((word) => {
        // Capitalize Latin words only
        return /[a-zA-Z]/.test(word)
          ? word.charAt(0).toUpperCase() + word.slice(1)
          : word;
      })
      .join(" ");

    return formatted;
  } catch (e) {
    return segment;
  }
};

export default function CustomBreadcrumbs({ items }) {
  const router = useRouter();
  const { t } = useTranslation();

  // Remove query params
  const cleanedPath = router.asPath.split("?")[0];
  const pathSegments = cleanedPath.split("/").filter((seg) => seg);

  // Default breadcrumbs from URL
  const fallbackBreadcrumbs = pathSegments.map((segment, index) => {
    const href = "/" + pathSegments.slice(0, index + 1).join("/");
    const isLast = index === pathSegments.length - 1;
    const normalizedSegment = segment?.toString().toLowerCase();
    const label =
      normalizedSegment === "sitemap"
        ? t("sitemap.title", "Site Map")
        : formatBreadcrumb(segment);

    return isLast ? (
      <Typography
        key={href}
        color="#40249B"
        fontSize={"12px"}
        lineHeight={"20px"}
      >
        {label}
      </Typography>
    ) : (
      <BreadcrumbLinkStyled
        key={href}
        href={href}
        style={{ textDecoration: "none", color: "#40249B" }}
      >
        {label}
      </BreadcrumbLinkStyled>
    );
  });

  // If items prop is valid, render them instead
  const dynamicBreadcrumbs =
    Array.isArray(items) && items.length > 0
      ? items.map(({ label, href }, idx) => {
          const resolvedLabel =
            typeof label === "string"
              ? t(label, { defaultValue: label })
              : label;
          return href ? (
            <BreadcrumbLinkStyled
              key={idx}
              href={href}
              style={{ textDecoration: "none", color: "#40249B" }}
            >
              {resolvedLabel}
            </BreadcrumbLinkStyled>
          ) : (
            <Typography
              key={idx}
              color="#40249B"
              fontSize={"12px"}
              lineHeight={"20px"}
            >
              {resolvedLabel}
            </Typography>
          );
        })
      : fallbackBreadcrumbs;

  return (
    <BreadcrumbStyled
      separator={
        <ChevronRightIcon
          style={{ width: "20px", height: "20px", color: "#40249B" }}
        />
      }
      aria-label="breadcrumb"
    >
      <BreadcrumbLinkStyled
        href="/"
        style={{ textDecoration: "none", color: "#40249B", display: "flex" }}
      >
        <HomeIcon style={{ height: "22px", width: "20px", color: "#40249B" }} />
      </BreadcrumbLinkStyled>
      {dynamicBreadcrumbs}
    </BreadcrumbStyled>
  );
}
